import React from 'react';
import PropTypes from 'prop-types';

import Box from 'components/atoms/Box/Box';
import Paragraph from 'components/atoms/Paragraph/Paragraph';
import { useMediaQuery, useTheme } from '@material-ui/core';

/**
 * Default Box component based on https://material-ui.com/components/box
 * @param {} props All possible props can be found in docs https://material-ui.com/components/box/#api
 */
export default function StakeStat(props) {
  const { value, valueLabel, boxColor, percentage } = props;
  const theme = useTheme();
  const themeColor = theme && theme.palette.primary.main;
  const textColor = props.textColor ? props.textColor : themeColor;
  const isMobile = useMediaQuery(theme.breakpoints.down('xs'));

  return (
    <Box>
      <Box
        borderRadius="2px"
        width="20px"
        height={'20px'}
        bgcolor={boxColor ? boxColor : themeColor}
        display="block"
        mb={1}
      ></Box>
      <Paragraph textSize={'20px'} variant="body1" textColor={textColor}>
        {value}
        {percentage ? '%' : ''}
      </Paragraph>
      <Paragraph variant="body1" textSize={isMobile ? '12px' : '14px'}>
        {valueLabel}
      </Paragraph>
    </Box>
  );
}

StakeStat.propTypes = {};

StakeStat.defaultProps = {};
